import { render, staticRenderFns } from "./CategoryCombinedChooseFrameModal.vue?vue&type=template&id=ce4eca4a&"
import script from "./CategoryCombinedChooseFrameModal.vue?vue&type=script&lang=js&"
export * from "./CategoryCombinedChooseFrameModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCombinedChooseFrameModal.vue?vue&type=style&index=0&id=ce4eca4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports